import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MentoringApiService } from '@app/mentoring/services/mentoring-api.service';
import { SearchOrigin } from '@app/search/services/search-tracker.service';
import { Observable, EMPTY } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { SearchSuggestionSource } from '@app/search/search-api.model';
import { NUM_TILE_RESULTS_PER_PAGE } from '@app/shared/search.token';

@Component({
  selector: 'dgx-search-mentors-view',
  templateUrl: './search-mentors-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchMentorsViewComponent extends SubscriberBaseDirective {
  public data: Observable<any>;
  public hasError = false;
  public searchOrigin = SearchOrigin.mentors;
  public suggestionSource = SearchSuggestionSource.AutoSuggestUsers;
  public location = 'Search Mentors';

  constructor(
    private mentoringApiService: MentoringApiService,
    private cdr: ChangeDetectorRef,
    @Inject(NUM_TILE_RESULTS_PER_PAGE)
    private readonly numResultsPerPage: number
  ) {
    super();
  }

  public search({ term, numResultsToSkip }) {
    this.data = this.mentoringApiService
      .getMentors({
        term: term,
        take: this.numResultsPerPage,
        excludeCurrentMentors: false,
        pageNum: numResultsToSkip / this.numResultsPerPage + 1,
      })
      .pipe(
        // Replay the stream for the many async pipes used in the markup
        share(),
        catchError(() => {
          this.hasError = true;
          this.cdr.markForCheck();
          // Return EMPTY here rather than of(null); EMPTY
          // is a "never" stream, perfect for when we want
          // to end the stream by returning an Observable
          // with no content.
          return EMPTY;
        })
      );
  }
}
